'use es6';

export const getStylesheets = state => state.stylesheets;
export const getStylesheetsById = state => state.stylesheets.byId;
export const getStylesheetsByPath = state => state.stylesheets.byPath;
export const getStylesheetsOrderById = state => state.stylesheets.orderById;